import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { RubriquesBlog } from '@components/rubriques-blog/models';
import { TranslatePipe } from '@ngx-translate/core';
import { TitleComponent } from '@shared/components/title';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { BlogCategory } from '@shared/services/elastic-search/models';

type FormattedCategories = { level1Category: string; subcategories: { name: string; url: string }[] }[];

@Component({
  selector: 'app-rubriques-blog',
  templateUrl: './rubriques-blog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, RouterLink, RouterLinkActive, TranslatePipe],
})
export class RubriquesBlogComponent extends AbstractDynamicComponent<RubriquesBlog> {
  protected readonly categories = toSignal(inject(ElasticSearchService).getBlogCategories(), { initialValue: [] });
  protected readonly formattedCategories = computed(() => this.getFormattedCategories(this.categories()));

  private getFormattedCategories(rawCategories: BlogCategory[]): FormattedCategories {
    const categoriesMap = rawCategories.reduce(
      (acc, cur) => {
        const category = (acc[cur.level1Category] ??= { subcategories: [] });
        category.subcategories.push({ name: cur.level2Category, url: cur.url });
        return acc;
      },
      {} as { [key: string]: { subcategories: { name: string; url: string }[] } }
    );

    return Object.keys(categoriesMap).map((level1Category) => ({
      level1Category,
      subcategories: categoriesMap[level1Category]!.subcategories,
    }));
  }
}
